// Module
var code = "<ul> <li> A longer repayment period</li> <li> More interest to repay (calculated as the weighted average of all loans and rounded up to the nearest 1/8 of 1%)</li> <li> Possible loss of current loan incentives</li> <li> Loss of deferment subsidy on Perkins loans</li> </ul> ";
// Exports
export default code;